import React from "react";
import { default as MUISlider } from "@mui/material/Slider";
import styled from "styled-components";

const StyledMUISlider = styled(MUISlider)``;

export const Slider = (props) => {
  return <StyledMUISlider {...props} />;
};
